import { Button } from '@/components/ui/button';
import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router-dom';

const HeroSection = () => {
  return (
    <section className="relative min-h-[85vh] w-full overflow-hidden bg-[#0F172A]">
      {/* Subtle gradient background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#0F172A] via-[#1e293b] to-[#0F172A]" />
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top_right,_rgba(2,132,199,0.15),_transparent_60%)]" />

      {/* Content */}
      <div className="relative z-10 h-full min-h-[85vh] flex items-end pb-16 md:pb-24">
        <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12 w-full">
          <div className="lg:grid lg:grid-cols-2 lg:gap-16 items-end">
            <div className="max-w-2xl space-y-6">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-extrabold tracking-tight text-white leading-tight">
                Authorization Execution
                <br />
                <span className="text-cta">Infrastructure.</span>
              </h1>
              <p className="text-lg text-white/80 leading-relaxed max-w-xl">
                Stop leaking earned revenue. LINK provides a defensible, automated enforcement layer that protects the hospital's bottom line while ensuring 100% compliance.
              </p>
              <div className="flex flex-col sm:flex-row items-start gap-3 pt-2">
                <Link to="/platform">
                  <Button
                    size="lg"
                    className="bg-cta hover:bg-cta/90 text-cta-foreground font-semibold px-8 py-6 text-base rounded-md min-h-[48px]"
                  >
                    Explore the Platform
                    <ArrowRight className="ml-2 h-5 w-5" />
                  </Button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
